module.exports = "\n\n<img src=\"../assets/images/404.png\" alt=\"404 message\">\n<a routerLink=\"/home\" routerLinkActive=\"home\">Home</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main